import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../../api"
import type { RoofColorTagOptionView } from "../../common/colors/roofColor/RoofColorTagOptionView"

export const getRoofColorTagOptionsRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, RoofColorTagOptionView[]> = {
	buildUrl: () => "/colors/roof-color/tag-options",
	method: "get",
	path: "/colors/roof-color/tag-options",
}
